import { gql } from '@apollo/client';

const PDF_GENERATION_FOR_PAIRING = gql`
  query pdfGenerationForPairing($id: String!, $tournamentCategory: String!, $timeControl: String, $pairingId: String) {
    pdfGenerationForPairing(id: $id, tournamentCategory: $tournamentCategory, timeControl: $timeControl, pairingId: $pairingId)
  }
`;

export default PDF_GENERATION_FOR_PAIRING;
